import { useCallback } from "react";
import { useMediaQuery } from "@mantine/hooks";
import { Button, Flex } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { client_selected } from "../../client";
import InterestDrawer from "../AccessInfos/InterestDrawer";
import { useTranslation } from "react-i18next";

type IProps = {
  drawer?: boolean;
};

const RedirectAuth = (props: IProps) => {
  const isSpider =
    client_selected.name !== "Empiricus" && client_selected.name !== "Genial";
  const navigate = useNavigate();
  const location = useLocation();
  const { setError, interest, accessExternalLink } = useAuth();
  const { t } = useTranslation();
  const isLargerThan550 = useMediaQuery("(min-width: 550px)");

  const handleRedirect = useCallback(
    (path: string) => {
      if (accessExternalLink && path === "/autenticacao/acessar-conta") {
        return window.open(accessExternalLink, "_target");
      }
      setError(null);
      const from = location.pathname;
      localStorage.setItem("redirect_path", from);
      navigate(path, { state: { from } });
    },
    // eslint-disable-next-line
    [location.pathname, navigate, open]
  );

  return (
    <Flex
      gap={{ base: 12, 991: 16, 1700: 24 }}
      h={{ base: 48, 991: 56 }}
      justify="space-between"
      align="center"
      w="100%"
    >
      <Flex
        gap={16}
        w={{
          base: props.drawer ? "100%" : 132,
          550: props.drawer ? "100%" : 250,
          1400: 336,
        }}
        align="center"
        p={props.drawer ? "0 24px" : "unset"}
        direction={props.drawer ? "column-reverse" : "row"}
      >
        {props.drawer || (!props.drawer && isLargerThan550 && isSpider) ? (
          <Button
            onClick={() => handleRedirect("/autenticacao/criar-conta")}
            fullWidth
            w="100%"
            variant="secondaryTransparent"
            h={{ base: 48, 991: 38, 1400: 56 }}
            styles={{
              root: {
                "@media (max-width: 1400px)": {
                  lineHeight: "24.8px",
                },
              },
            }}
          >
            {t("global.navbar.button_signup")}
          </Button>
        ) : null}

        <Button
          onClick={() => handleRedirect("/autenticacao/acessar-conta")}
          fullWidth
          w="100%"
          variant="secondary"
          h={{ base: 48, 991: 38, 1400: 56 }}
          styles={{
            root: {
              "@media (max-width: 1400px)": {
                lineHeight: "24.8px",
              },
            },
          }}
        >
          {t("global.navbar.button_signin")}
        </Button>
      </Flex>
      {isSpider && interest.length > 0 ? <InterestDrawer /> : null}
    </Flex>
  );
};
export default RedirectAuth;
